"use client"

import { Robot, User } from "@phosphor-icons/react"
import { ChartWithConfigId } from "@tokenterminal/core/feature/chart/ChartWithConfigId"
import { ChartContextProvider } from "@tokenterminal/core/feature/chart/tt-ui-chart/ChartContext"
import { ErrorBoundary } from "@tokenterminal/core/ui/ErrorBoundary"
import { Icon } from "@tokenterminal/core/ui/icon/Icon"
import { ClientOnlySuspense } from "@/components/ClientOnlySuspense"
import { FADE_MASK_STYLE } from "@/utils/masonryMask"

// Same chart ID as homepage - Fees for L1 blockchains
const CHART_ID = "ZDVhMWFmNjBhMmY1NDMzODU2MTE1YjQx"

export function MCPChartDemo() {
  return (
    <div
      className="relative border-t border-l border-solid border-border-default rounded-tl-xl bg-bg-default"
      style={{ overflow: "hidden", ...FADE_MASK_STYLE }}
    >
      {/* Chat Content */}
      <div className="p-4 flex flex-col gap-4">
        {/* User message */}
        <div className="flex gap-2 justify-end">
          <div className="bg-blue-600 text-white rounded-xl rounded-br-sm px-3 py-2 max-w-[85%]">
            <p className="text-xs">Show me fees for major L1 blockchains over the past year</p>
          </div>
          <div className="w-6 h-6 rounded-full bg-blue-600 flex items-center justify-center shrink-0">
            <Icon as={User} className="w-3 h-3 text-white" />
          </div>
        </div>

        {/* Assistant response with chart */}
        <div className="flex gap-2 justify-start">
          <div className="w-6 h-6 rounded-full bg-bg-surface border border-border-default flex items-center justify-center shrink-0">
            <Icon as={Robot} className="w-3 h-3 text-fg-secondary" />
          </div>
          <div className="flex-1 flex flex-col gap-2">
            <div className="bg-bg-surface border border-border-default rounded-xl rounded-bl-sm px-3 py-2">
              <p className="text-xs text-fg-default">
                Here are the fees for major L1 blockchains over the past year:
              </p>
            </div>
            {/* Chart card */}
            <div className="bg-bg-surface border border-border-default rounded-xl p-4">
              <div className="mb-2">
                <span className="text-xs font-medium text-fg-default">Fees for L1 blockchains</span>
              </div>
              <div className="h-[220px] w-full">
                <ErrorBoundary fallback={null}>
                  <ClientOnlySuspense>
                    <ChartContextProvider>
                      <ChartWithConfigId
                        id={CHART_ID}
                        isVisible
                        showDescription={false}
                        showTitle={false}
                      />
                    </ChartContextProvider>
                  </ClientOnlySuspense>
                </ErrorBoundary>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
